import { compose } from 'lodash/fp';
import { InterviewRouterEnhancer } from '../interviewInterface';
import { createAssistantTrackingStrategy } from './tracking';

export function createAssistantMiddleware(): InterviewRouterEnhancer {
    return compose(createAssistantTrackingStrategy());
}
